"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    display: flex;
    gap: 12px;
`;exports.default=e,exports.styles=e;
//# sourceMappingURL=styles.js.map
